import { Modal } from '@material-ui/core';
import styled from 'styled-components';
import { Button } from 'src/components/atoms/button';
import { Paper } from 'src/components/atoms/paper';
import { Typography } from 'src/components/atoms/typography';
import HeaderfulContainer from 'src/components/molecules/headerfulContainer';

export const BoxPickingContainer = styled(HeaderfulContainer)`
  && {
    position: relative;
    margin-right: 24px;
    flex-basis: 75%;
    max-width: 75%;
    padding-bottom: 96px;
  }
`;

export const ProgressText = styled(Typography)`
  && {
    color: ${props => props.theme.palette.grayScale[80]};
    font-size: ${props => props.theme.typography.fontSize.medium};
    margin-bottom: 16px;
  }
`;

export const ScanArea = styled.div`
  border: 2px dashed ${props => props.theme.palette.primary.light};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
`;

export const ScanHint = styled(Typography)`
  && {
    color: ${props => props.theme.palette.primary.darker};
    font-size: ${props => props.theme.typography.fontSize.large};
    font-weight: bold;
    text-align: center;
  }
`;

export const LastBoxInfo = styled(Typography)`
  && {
    color: ${props => props.theme.palette.grayScale[80]};
    font-size: ${props => props.theme.typography.fontSize.small};
    text-align: center;
    margin-top: 8px;
  }
`;

export const JoinPackageRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
`;

export const ActionButton = styled(Button)`
  && {
    margin-right: 10px;
  }
`;

export const SectionTitle = styled(Typography)`
  && {
    color: ${props => props.theme.palette.grayScale[80]};
    font-size: ${props => props.theme.typography.fontSize.medium};
    font-weight: bold;
    margin: 8px 0;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 24px;
  font-family: inherit;
  th,
  td {
    text-align: left;
    padding: 6px 8px;
    border-bottom: 1px solid ${props => props.theme.palette.grayScale[20]};
    color: ${props => props.theme.palette.grayScale[80]};
  }
`;

export const MissingCell = styled.td<{ missing: boolean }>`
  && {
    font-weight: ${props => (props.missing ? 'bold' : 'normal')};
    color: ${props => (props.missing ? props.theme.palette.primary.darker : props.theme.palette.grayScale[80])};
  }
`;

export const ButtonsContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  right: 24px;
  bottom: 24px;
`;

export const CircularProgressContainer = styled.div`
  width: 147px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledModal = styled(Modal)`
  && {
  }
`;

export const ModalContainer = styled(Paper)`
  && {
    width: 560px;
    max-height: 80vh;
    overflow-y: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const ModalTitle = styled(Typography)`
  && {
    color: ${props => props.theme.palette.grayScale[80]};
    font-size: ${props => props.theme.typography.fontSize.large};
    font-weight: bold;
    margin-bottom: 16px;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
`;
